// extracted by mini-css-extract-plugin
export default {"logo":"index_logo_5U9-f","breadcrumbs":"index_breadcrumbs_JB0YY"};